import { observer } from "mobx-react"

import { AgentAccess } from "src/components/AgentSelection"
import { KnowledgeItemStore } from "src/modals/knowledge-items/store"
import { useStore } from "src/store/lib/useStore"

export const KnowledgeItemsAgentAccess = observer(() => {
    const store = useStore(KnowledgeItemStore)

    return <AgentAccess store={store} />
})
